<template>
  <div v-show="hotRecommendList.length" class="hot-recommend">
    <div class="hot-recommend-title">
      <iconpark-icon name="hot-fill" size="20"></iconpark-icon>
      <h2>{{ $t('re-men-tui-jian') }}</h2>
    </div>
    <div class="hot-recommend-divider" />
    <div class="hot-recommend-content">
      <a
        v-for="item in hotRecommendList"
        :key="item.recommend_title"
        :href="`${item.article_url}${item.paragraph_id ? `?target=${item.paragraph_id}` : ''}`"
        class="hot-recommend-item"
      >
        <div class="hot-recommend-item-title flex-center">
          {{ item.recommend_title }}
          <XTag v-if="item.is_show_new" type="new" class="ml-[4px]" size="small" />
        </div>
        <iconpark-icon name="breadcrumb-separator"></iconpark-icon>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getHotRecommend, type IHotRecommend } from '~/api/module/help-center';

const hotRecommendList = ref<IHotRecommend[]>([]);

const { data: hotRecommendListData } = useAsyncData('hotRecommendList', () => getHotRecommend(), {
  immediate: true,
});

watch(
  hotRecommendListData,
  newVal => {
    hotRecommendList.value = newVal?.data || [];
  },
  {
    immediate: true,
  },
);
</script>

<style scoped lang="scss">
.hot-recommend {
  width: 1000px;
  margin: 0 auto;
  border: 1px solid var(--back-5);
  border-radius: 12px;
  padding: 24px 40px;
  .hot-recommend-title {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    color: var(--text-color);
    h2 {
      font-size: 18px;
      margin: 0;
    }
  }
  .hot-recommend-divider {
    width: 100%;
    height: 1px;
    background-color: var(--back-5);
    margin: 20px 0;
  }
  .hot-recommend-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 80px;
    .hot-recommend-item {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      color: var(--text-1);
      &:hover {
        .hot-recommend-item-title,
        iconpark-icon {
          color: var(--primary-color);
        }
      }
      .hot-recommend-item-title {
        font-size: 14px;
      }
    }
  }
}
</style>
